// ----------------------------------------------------------------------

export const PRIMARY_COLOR = "#6C5AF4";
